import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./About.css";

gsap.registerPlugin(ScrollTrigger);

const About = () => {
    const containerRef = useRef(null);

    useLayoutEffect(() => {
        const ctx = gsap.context(() => {
            // Header Animation
            gsap.from(".about-header > *", {
                y: 50,
                opacity: 0,
                duration: 1.2,
                stagger: 0.2,
                ease: "power3.out"
            });

            // Section Animations
            gsap.utils.toArray(".about-section").forEach((section) => {
                gsap.to(section, {
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    scrollTrigger: {
                        trigger: section,
                        start: "top 80%",
                        toggleActions: "play none none reverse"
                    }
                });
            });
        }, containerRef);
        return () => ctx.revert();
    }, []);

    return (
        <div className="about-container" ref={containerRef}>
            <header className="about-header">
                <h1>About Us</h1>
                <p>Shaping the Future of AI & Cloud Innovation</p>
            </header>

            <section className="about-section glass-panel" style={{ padding: '40px' }}>
                <h2>Our Story</h2>
                <p>
                    In a world where AI, deep learning, and cloud technologies evolve at lightning speed,
                    understanding them can feel overwhelming. Our mission is simple: to demystify complex
                    tech concepts and make them accessible to everyone. We believe that knowledge is the
                    bridge to the future.
                </p>
            </section>

            <div className="about-divider"></div>

            <section className="about-section">
                <h2>Our Audience</h2>
                <p>
                    Our audience is our true north. We're more than a platform; we're a community where tech
                    veterans and novices alike can learn, engage, and contribute to the ever-evolving narrative
                    of AI and Cloud Technology. Whether you are a researcher pushing boundaries or a student
                    just starting out, you have a place here.
                </p>
            </section>

            <div className="about-divider"></div>

            <section className="about-section">
                <h2>Our Mission</h2>
                <p>
                    In a world where technology's pace often outstrips comprehension, our mission stands clear:
                    to empower our readers by transforming the complex into the comprehensible. We're committed
                    to making AI and Cloud Technology accessible, engaging, and enlightening for all, irrespective
                    of their technical background.
                </p>
            </section>

            <footer className="about-footer">
                <p>&copy; 2024 Galilee Research - AI & Cloud Innovation</p>
            </footer>
        </div>
    );
};

export default About;
